import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
  state:{
    searchKey:'',
    chooseDay:'',
    LOADING: false,
    NODATA: false,
    chooseDayCount:0,
    showSwiper:false,
    calendar:[]
  },
  mutations:{
    setSearchKey(state, searchKey){
      state.searchKey = searchKey
    },
    setChooseDay(state, chooseDay){
      state.chooseDay = chooseDay
    },
    showLoading(state){
      state.LOADING = true
    },
    hideLoading (state) {
      state.LOADING = false
    },
    hasData(state){
      state.NODATA = false
    },
    noData(state){
      state.NODATA = true
    },
    needScroll2list(state){
      state.scroll2list = true
    },
    noneedScroll2list(state){
      state.scroll2list = false
    },
    incrementChooseDay(state){
      state.chooseDayCount += 1
      // console.log('state.chooseDayCount='+state.chooseDayCount)
    },
    showSwiper(state){
      state.showSwiper = true
    },
    hideSwiper(state){
      state.showSwiper = false
    },
    setCalendar(state, calendar){
      state.calendar = calendar
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js